document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('img[data-markdown]').forEach((img) => {
    img.addEventListener('mousedown', (e) => {
      if (e.which === 3) {
        e.preventDefault();
        navigator.clipboard.writeText(img.getAttribute('data-markdown'));

        img.style.opacity = 0.1;

        setTimeout(() => {
          img.style.transition = 'opacity 2000ms';
          img.style.opacity = '';
          setTimeout(() => {
            img.style.transition = '';
          }, 2000);
        }, 50);
      }
    });

    img.addEventListener('contextmenu', (e) => {
      e.preventDefault();
    });
  });

});
